import Vue from 'vue'
import { Tab, Tabs, Checkbox, CheckboxGroup, Dialog, ActionSheet, Icon, Search, Swipe, DatetimePicker, SwipeItem, Grid, GridItem, Toast, Button, Switch, Rate, Tabbar, TabbarItem, NavBar, Form, Field, RadioGroup, Radio, Popup, Calendar, Cell, CellGroup, Empty, Image as VanImage, Picker, Row, Col, ShareSheet, Collapse, CollapseItem } from 'vant'


Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Dialog)
Vue.use(ActionSheet)
Vue.use(Icon)
Vue.use(Search)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(Toast)
Vue.use(NavBar)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Rate)
Vue.use(Button)
Vue.use(Switch)
Vue.use(Form)
Vue.use(Field)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(DatetimePicker)
Vue.use(Popup)
Vue.use(Calendar)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Empty)
Vue.use(VanImage)
Vue.use(Picker)
Vue.use(Row)
Vue.use(Col)
Vue.use(ShareSheet)
Vue.use(Collapse)
Vue.use(CollapseItem)
